import { newLogger } from "@/utils/util";
import i18n from "@/plugins/i18n";
import network from "../../../utils/network";
import axios from "axios";
import Vue from "vue";
import eventBus, { EVENTS } from "@/utils/eventBus";

let logger = newLogger("i18nStore");

const urls = {
  countriesList: `/api/administration/external/country/countries/list`,
  publicTokens: (lang) => `/api/tokens/public/${lang}`,
  internalTokens: (lang) => `/tokens/internal/${lang}`,
};

/**
 * i18n plugin's store
 * Stores the i18n messages, manages the vue-i18n plugin
 */

let savedCountry = {
  id: 1,
  flag: "🇭🇺",
  languageIso: "hu-HU",
  currencyIso: "HUF",
};

const localStorageCountry = JSON.parse(
  localStorage.getItem("ic-saved-country")
);

if (localStorageCountry) {
  savedCountry = localStorageCountry;
}

const initState = () => {
  return {
    countries: [],
    country: savedCountry,
    tokens: {},
  };
};

const actions = {
  fetchAllCountries: async ({ commit }) => {
    try {
      const { data: countries } = await axios.get(urls.countriesList);
      commit("saveCountriesList", countries);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchTokensByLanguage: async ({ commit }, lang) => {
    try {
      const { data: tokens } = await axios.get(urls.publicTokens(lang));

      commit("setTokensForLanguage", {
        lang,
        tokens,
      });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchInternalTokensByLanguage: async ({ commit }, lang) => {
    try {
      const axios = await network.connection();
      const { data: tokens } = await axios.get(urls.internalTokens(lang));

      commit("setTokensForLanguage", {
        lang,
        tokens,
      });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  setTokensForLanguage: (state, { lang, tokens }) => {
    if (state.tokens[lang]) {
      let currentTokens = state.tokens[lang];
      Vue.set(state.tokens, lang, Object.assign({}, tokens, currentTokens));
    } else {
      Vue.set(state.tokens, lang, tokens);
    }

    i18n.locale = lang;
    i18n.setLocaleMessage(lang, state.tokens[lang]);
    eventBus.$emit(EVENTS.TOKENS_LOADED);
  },

  saveCountriesList: (state, countries) => {
    Vue.set(state, "countries", countries);
  },

  setCountryByLanguageIso: (state, locale) => {
    const country = state.countries.find(
      (country) => country.languageIso === locale
    );
    if (country) {
      localStorage.setItem("ic-saved-country", JSON.stringify(country));
      Vue.set(state, "country", country);
    }
  },

  setCountryById: (state, id) => {
    const country = state.countries.find((country) => country.id === id);
    if (country) {
      localStorage.setItem("ic-saved-country", JSON.stringify(country));
      Vue.set(state, "country", country);
    }
  },
};

const getters = {
  countries: (state) => {
    return state.countries;
  },
  currencies: (state) => {
    return new Set(state.countries.map((country) => country.currencyIso));
  },
  country: (state) => {
    return state.country;
  },
  locale: (state) => {
    return state.country.languageIso;
  },
  lastNameFirst: (state) => {
    return state.country.lastNameFirst;
  },
  phoneMask: (state) => {
    return `+${state.country.phoneCountryCode.replaceAll(
      /[0-9]/g,
      "0"
    )} ${state.country.phoneFormat.replaceAll("9", "0")}`;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
